var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    d: "M23.375,4V2 c-0.02-0.37-0.27-0.37-0.38-0.37h-12c-0.37,0.01-0.37,0.26-0.37,0.37v15.99c0.01,0.38,0.26,0.38,0.37,0.38h12 c0.38-0.021,0.38-0.271,0.38-0.38v-1"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M24.5,14.25c2.071,0,3.75-1.679,3.75-3.75c0-2.071-1.679-3.75-3.75-3.75 s-3.75,1.679-3.75,3.75C20.75,12.571,22.429,14.25,24.5,14.25"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    cx: 24.5,
    cy: 10.5,
    r: 3.75
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 13.495,
    y1: 5.5,
    x2: 19.995,
    y2: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 13.495,
    y1: 9.5,
    x2: 17.995,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 13.495,
    y1: 13.5,
    x2: 18.495,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 27.745,
    y1: 13.75,
    x2: 32.245,
    y2: 18.25
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuchen);
export default __webpack_public_path__ + "static/media/suchen.658b551b55112261c55f669b6b4faa87.svg";
export { ForwardRef as ReactComponent };